import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface DeleteBulkRoleMenusRequest {
  ids: number[];
}

export type DeleteBulkRoleMenusResponse = {
  isSuccess: boolean;
  message: string;
  data: any;
};

async function deleteBulkRoleMenus(
  data: DeleteBulkRoleMenusRequest
): Promise<DeleteBulkRoleMenusResponse> {
  try {
    return (await axiosInstance.post("/RoleMenu/DeleteBulk", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useDeleteBulkRoleMenus() {
  return useMutation<DeleteBulkRoleMenusResponse, Error, DeleteBulkRoleMenusRequest>(
    (variables) => deleteBulkRoleMenus(variables)
  );
}
